import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import { authGuard } from '../auth/authGuard'

Vue.use(VueRouter)

const routes = [
  {
    // Document title tag
    // We combine it with defaultDocumentTitle set in `src/main.js` on router.afterEach hook
    meta: {
      title: 'Dashboard'
    },
    path: '/',
    name: 'home',
    component: Home,
    beforeEnter: authGuard
  },
  {
    meta: {
      title: 'Products'
    },
    path: '/products',
    name: 'products',
    beforeEnter: authGuard,
    component: () => import(/* webpackChunkName: "products" */ '../views/Products.vue')
  },
  {
    meta: {
      title: 'Job Sheets'
    },
    path: '/jobSheets',
    name: 'jobSheets',
    beforeEnter: authGuard,
    component: () => import(/* webpackChunkName: "jobSheets" */ '../views/JobSheets.vue')
  },
  {
    meta: {
      title: 'Allocate Load'
    },
    path: '/allocateLoad',
    name: 'allocateLoad',
    beforeEnter: authGuard,
    component: () => import(/* webpackChunkName: "allocateLoad" */ '../views/Allocate Load.vue')
  },
  {
    meta: {
      title: 'Find Load'
    },
    path: '/findLoad',
    name: 'findLoad',
    beforeEnter: authGuard,
    component: () => import(/* webpackChunkName: "findLoad" */ '../views/Find Load.vue')
  },
  {
    meta: {
      title: 'Add Job'
    },
    path: '/addJob',
    name: 'addJob',
    beforeEnter: authGuard,
    component: () => import(/* webpackChunkName: "addJob" */ '../views/Add Job.vue')
  },
  {
    meta: {
      title: 'Edit Job'
    },
    path: '/editJob/id/:id',
    name: 'editJob',
    beforeEnter: authGuard,
    component: () => import(/* webpackChunkName: "addJob" */ '../views/Add Job.vue')
  },
  {
    meta: {
      title: 'Add Load'
    },
    path: '/addLoad',
    name: 'addLoad',
    beforeEnter: authGuard,
    component: () => import(/* webpackChunkName: "addLoad" */ '../views/Add Load.vue')
  },
  {
    meta: {
      title: 'Loads'
    },
    path: '/loads',
    name: 'loads',
    beforeEnter: authGuard,
    component: () => import(/* webpackChunkName: "loads" */ '../views/Loads.vue')
  },
  {
    meta: {
      title: 'Users'
    },
    path: '/users',
    name: 'users',
    beforeEnter: authGuard,
    component: () => import(/* webpackChunkName: "users" */ '../views/Users.vue')
  },
  {
    meta: {
      title: 'Add User'
    },
    path: '/addUser',
    name: 'addUser',
    beforeEnter: authGuard,
    component: () => import(/* webpackChunkName: "addUser" */ '../views/Add User.vue')
  },
  {
    meta: {
      title: 'Edit User'
    },
    path: '/editUser/email/:email',
    name: 'editUser',
    beforeEnter: authGuard,
    component: () => import(/* webpackChunkName: "editUser" */ '../views/Add User.vue')
  },
  {
    meta: {
      title: 'Address'
    },
    path: '/address',
    name: 'address',
    beforeEnter: authGuard,
    component: () => import(/* webpackChunkName: "address" */ '../views/Address.vue')
  },
  {
    meta: {
      title: 'Find Job'
    },
    path: '/findJob',
    name: 'findJob',
    beforeEnter: authGuard,
    component: () => import(/* webpackChunkName: "findJob" */ '../views/Find Job.vue')
  },
  {
    meta: {
      title: 'Clients'
    },
    path: '/clients',
    name: 'clients',
    beforeEnter: authGuard,
    component: () => import(/* webpackChunkName: "client" */ '../views/Clients.vue')
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
